import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EFormControl } from '../../e-form-control.model';
import * as _ from 'lodash';
import { Lookup } from '../../../lookup/lookup.model';
import { EFormService } from '../../e-form.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GeneralConfirmationComponent } from '../../../controls/general-confirmation/general-confirmation.component';
import { ErrorList } from '../../../controls/error-prompt/error-list.model';
import { MergeFieldDialogComponent } from '../merge-field-dialog/merge-field-dialog.component';
import { EFormDesignerService } from '../e-form-designer.service';
import { LoginService } from '../../../../shared-modules/login/login.service';

@Component({
  selector: 'app-e-form-choices-dialog',
  templateUrl: './e-form-choices-dialog.component.html',
  styleUrls: ['./e-form-choices-dialog.component.css']
})
export class EFormChoicesDialogComponent implements OnInit {

  dataSource: MatTableDataSource<Lookup> = new MatTableDataSource<Lookup>();
  columnsToDisplay = ['DragHandle', 'Choice', 'Actions'];
  control: EFormControl;
  showNoDefaultCheckbox = false;
  noDefault = true;
  dbField: boolean;
  errors: ErrorList[] = [];
  idCount = 0;
  defaultId: string;
  focusControlindex = 0;
  isV10: boolean;
  showCriticalCondition: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EFormChoicesDialogComponent>,
    private eFormService: EFormService,
    private dialog: MatDialog,
    private eFormDesignerService: EFormDesignerService,
    private loginService: LoginService
  ) {
    this.control = _.cloneDeep(data.selectedControl);
    this.showCriticalCondition = data.showCriticalCondition;
  }

  ngOnInit() {
    this.isV10 = this.loginService.LoginSettings.V10;
    if (this.control.ControlType == this.eFormService.controlTypes.buttons) {
      if (this.showCriticalCondition) {
        this.columnsToDisplay = ['DragHandle', 'Choice', 'IsCritical', 'Actions'];
      }
      else {
        this.columnsToDisplay = ['DragHandle', 'Choice', 'Actions'];
      }
      if (!this.control.DropdownOptions || this.control.DropdownOptions.length == 0) {
        this.addClick();
        this.addClick();
      }
    }
    else if (this.control.ControlType == this.eFormService.controlTypes.dropdown) {
      if (this.showCriticalCondition) {
        this.columnsToDisplay = ['DragHandle', 'Choice', 'Default', 'IsCritical', 'Actions'];
      }
      else {
        this.columnsToDisplay = ['DragHandle', 'Choice', 'Default', 'Actions'];
      }
      this.showNoDefaultCheckbox = true;
      if (!this.control.DropdownOptions || this.control.DropdownOptions.length == 0) {
        this.addClick();
      }
    }
    else if (this.control.ControlType == this.eFormService.controlTypes.radioButtons) {
      if (this.showCriticalCondition) {
        this.columnsToDisplay = ['DragHandle', 'Choice', 'Default', 'IsCritical', 'Actions'];
      }
      else {
        this.columnsToDisplay = ['DragHandle', 'Choice', 'Default', 'Actions'];
      }
      this.showNoDefaultCheckbox = false;
      this.noDefault = false;
      if (!this.control.DropdownOptions || this.control.DropdownOptions.length == 0) {
        this.addClick();
        this.addClick();
        this.control.DropdownOptions[0].CodeDescription = '';
        this.control.Value = '';
      }
    }

    if (this.control.LinkedDBField != -1) {
      this.dbField = true;
    }

    for (let i = 0; i < this.control.DropdownOptions.length; i++) {
      this.control.DropdownOptions[i].Id = this.idCount.toString();
      this.idCount++;
      if (!this.dbField) {
        if (this.control.Value == this.control.DropdownOptions[i].CodeDescription) {
          this.defaultId = this.control.DropdownOptions[i].Id;
        }
      }
      else {
        if (this.control.Value == this.control.DropdownOptions[i].Code) {
          this.defaultId = this.control.DropdownOptions[i].Id;
        }
      }
      
      this.setDefaultOptionFlags();
    }

    this.dataSource.data = this.control.DropdownOptions;
    if (this.control.Value && this.showNoDefaultCheckbox) {
      this.noDefault = false;
    }

    this.eFormDesignerService.observableChoiceMergeFieldClickedStream$.subscribe(mergeField => {
      this.setData(mergeField);
    });
  }

  cancelClick() {
    this.dialogRef.close();
  }

  saveClick() {
    this.validate();
    if (this.errors.length == 0) {
      this.control.DropdownOptions.forEach(opt => {
        if (!this.dbField) {
          opt.Code = opt.CodeDescription;
        }
      });
      this.dialogRef.close(this.control);
    }
  }

  validate() {
    this.errors = [];
    if (this.control.ControlType == this.eFormService.controlTypes.buttons || this.control.ControlType == this.eFormService.controlTypes.radioButtons) {
      if (!this.control.DropdownOptions || this.control.DropdownOptions.length < 2) {
        this.errors.push({
          fieldName: null,
          fieldRef: null,
          errorMsg: 'Must have at least two choices.'
        });
      }
      const blankOption = this.control.DropdownOptions.find(o => !o.CodeDescription || o.CodeDescription.trim() == '');
      if (blankOption) {
        this.errors.push({
          fieldName: null,
          fieldRef: null,
          errorMsg: 'Blank choices are not allowed.'
        });
      }
    }
    else if (this.control.ControlType == this.eFormService.controlTypes.dropdown) {
      if (!this.control.DropdownOptions || this.control.DropdownOptions.length == 0) {
        this.errors.push({
          fieldName: null,
          fieldRef: null,
          errorMsg: 'Must have at least one choice.'
        });
      }
      else if (this.control.DropdownOptions.length == 1 && this.control.DropdownOptions[0].CodeDescription.trim() == '') {
        this.errors.push({
          fieldName: null,
          fieldRef: null,
          errorMsg: 'Must have at least one non-blank choice.'
        });
      }
    }
    // check for duplicate choices
    let duplicateFound = false;
    for (let i = 0; i < this.control.DropdownOptions.length; i++) {
      if (duplicateFound) {
        break;
      }
      const choiceA = this.control.DropdownOptions[i];
      for (let c = i + 1; c < this.control.DropdownOptions.length; c++) {
        const choiceB = this.control.DropdownOptions[c];
        if (choiceA.CodeDescription.trim() == choiceB.CodeDescription.trim()) {
          duplicateFound = true;
          break;
        }
      }
    }
    if (duplicateFound) {
      this.errors.push({
        fieldName: null,
        fieldRef: null,
        errorMsg: 'Duplicate choices are not allowed.'
      });
    }
    if (!this.noDefault) {
      this.updateDefault();
      if (!this.control.DropdownOptions || this.control.DropdownOptions.find(o =>
                                                                                    (!this.dbField && o.CodeDescription == this.control.Value) ||
                                                                                    (this.dbField && o.Code == this.control.Value)
                                                                            ) == null) {
        this.errors.push({
          fieldName: null,
          fieldRef: null,
          errorMsg: 'Must select a default choice.'
        });
      }
    }
  }

  rowDrop(event: CdkDragDrop<any, any>) {
    const prevIndex = this.dataSource.data.findIndex((d) => d === event.item.data);
    moveItemInArray(this.control.DropdownOptions, prevIndex, event.currentIndex);
    this.dataSource.data = this.control.DropdownOptions;
  }

  defaultClick(option: Lookup) {
    if (this.dbField) {
      this.control.Value = option.Code;
    }
    else {
      this.control.Value = option.CodeDescription;
    }
    this.defaultId = option.Id;

    this.setDefaultOptionFlags();
  }

  updateDefault() {
    const defaultOption: Lookup = this.control.DropdownOptions.find(o => o.Id == this.defaultId);

    if (defaultOption) {
      if (this.dbField) {
        this.control.Value = defaultOption.Code;
      }
      else {
        this.control.Value = defaultOption.CodeDescription;
      }
    }
    
    this.setDefaultOptionFlags();
  }

  setDefaultOptionFlags() {
    this.control.DropdownOptions.forEach( option => {
      option.Default = option.Id == this.defaultId;
    });
  }

  deleteClick(option: Lookup) {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Delete Choice';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete the "' + option.CodeDescription + '" choice?';
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        const i = this.control.DropdownOptions.findIndex(o => o.CodeDescription == option.CodeDescription);
        if (i >= 0) {
          this.control.DropdownOptions.splice(i, 1);
        }
        this.dataSource.data = this.control.DropdownOptions;
      }
    });
  }

  addClick() {
    const newChoice = new Lookup();
    newChoice.Code = '';
    newChoice.CodeDescription = '';
    newChoice.Id = this.idCount.toString();
    this.idCount++;
    this.control.DropdownOptions.push(newChoice);
    this.dataSource.data = this.control.DropdownOptions;
  }

  noDefaultChange() {
    if (this.noDefault) {
      this.control.Value = null;
    }
    else {
      if (this.control.DropdownOptions && this.control.DropdownOptions.length > 0) {
        this.control.Value = this.control.DropdownOptions[0].CodeDescription;
      }
    }
  }

  displayMergeFields() {
    const mergeFieldDialog = this.dialog.open(MergeFieldDialogComponent, {
      height: '80vh',
      minWidth: '300px',
      hasBackdrop: false,
      disableClose: true,
      data: {
        noOperation: true
      }
    });
  }

  focusControl(index: number) {
    this.focusControlindex = index;
  }

  setData(field) {
    // this.control.DropdownOptions[this.focusControlindex].CodeDescription += field.FieldName;
    if (this.control.DropdownOptions[this.focusControlindex].CodeDescription != null && this.control.DropdownOptions[this.focusControlindex].CodeDescription != undefined) {
      this.control.DropdownOptions[this.focusControlindex].CodeDescription += field.FieldName;
      }
      else {
        this.control.DropdownOptions[this.focusControlindex].CodeDescription = field.FieldName;
      }
      this.dataSource.data = this.control.DropdownOptions;
  }

}
